import { makeStyles, Text } from '@rneui/themed'
import { Shift } from '@nextforce/api'
import React from 'react'

interface Props {
  shift?: Shift
}

export function ShiftCompensationMessageView({ shift }: Props) {
  const styles = useStyles()

  if (!shift?.compensationMessage) {
    return null
  }

  return <Text style={styles.text}> {shift.compensationMessage}</Text>
}

const useStyles = makeStyles(theme => ({
  text: {
    color: theme.colors?.primary,
  },
}))
